import React from "react";
import { Row, Col } from "reactstrap";

const PrestaManquanteBloc = (props) => {
  return (
    <section className="p-section">
      <Row className="bloc-about">
        <Col
          sm={12}
          className="align-self-center content-bloc content-bloc-white"
          style={{ backgroundColor: "#DB7124", color: "white" }}
        >
          <div>
            <p style={{ textAlign: "center" }}>
              <a
                className="hover-grey"
                href="mailto:contact@centralis.site?subject=Prestation manquante"
              >
                Si vous souhaitez une prestation très spécifique, introuvable
                dans le catalogue, contactez nous pour mettre en place un marché
                subséquent dans la catégorie de métier correspondante
              </a>
            </p>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default PrestaManquanteBloc;
